<wl-card>
  <div class="mct-flex mct-row mct-gap-11"  >
    <div>
      <label class="light-text">{{ 'common.from' | translate | ucfirst }}</label>
      <wl-date-selector appendTo="body" [(ngModel)]="searchParams.SubmissionDateStart"></wl-date-selector>
    </div>
    <div>
      <label class="light-text">{{ 'common.to' | translate | ucfirst }}</label>
      <wl-date-selector
        appendTo="body"
        [(ngModel)]="searchParams.SubmissionDateEnd"
        [minDate]="searchParams.SubmissionDateStart"
      ></wl-date-selector>
    </div>
  </div>
  <div class="mt-27">
    <!-- Search param footer -->
    <ng-content></ng-content>
  </div>
</wl-card>
